/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type SurveyDialogView = typeof SurveyDialogView[keyof typeof SurveyDialogView];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyDialogView = {
  All: 'All',
  Unread: 'Unread',
} as const;
